import React from 'react'

import { Form, Col } from '_zari/core'

const TituloFormGroup = ({ iValue }) => {
  return (
    <Form.Group>
      <Form.Label text='TITULO' htmlFor='input-titulo' md={4} />
      <Col md={8}>
        <Form.InputText disabled id='input-titulo' defaultValue={iValue} />
      </Col>
    </Form.Group>
  )
}

export default React.memo(TituloFormGroup)
